import { createAction, props } from '@ngrx/store';

export const updateDetails = createAction(
  '[YourDetails] Update Details',
  props<{ updatedDetails: any}>()
);

export const resetDetails = createAction(
  '[YourDetails] Reset Details'
);

export const resetError = createAction(
  '[YourDetails] Reset Error'
);

export type YourDetailsActionsUnion = ReturnType<typeof updateDetails | typeof resetDetails | typeof resetError>;
